import * as OperacacoItemMenuSistemaActions from '../actions/operacao-item-menu.action';
import { OperacaoItemMenuSistema } from '../dominios/operacao-item-menu-sistema';

export const operacaoItemMenuSistema = new Array<OperacaoItemMenuSistema>();

export function operacacoItemMenuSistemaReducer(state: OperacaoItemMenuSistema[] = operacaoItemMenuSistema,
    action: OperacacoItemMenuSistemaActions.Actions) {
    switch (action.type) {
        case OperacacoItemMenuSistemaActions.ADD_OPERACAO_ITEM_MENU_SISTEMA:
            {
                state = action.payload;
                return state;
            };

        case OperacacoItemMenuSistemaActions.CLEAR_OPERACAO_ITEM_MENU_SISTEMA:
            {
                state = new Array<OperacaoItemMenuSistema>();
                return state;
            }

        default:
            return state;
    }

}





// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/reducers/operacaco-item-menu-sistema.reducer.ts